import { styled } from "../../../styled-components";

export const Wrapper = styled.div`
    padding: 0 ${p => p.theme.pageMarginMedium}px 75px;

    flex-grow: 1;
`;

export const CommentButton = styled.div`
    position: sticky;
    right: 0px;
    bottom: calc(var(--bottom-bar-padding) + var(--safe-area-inset-bottom));
`;
